module.exports = __webpack_public_path__ + "img/bluetooth.e1d0195a.svg";